/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Backend_Development_Ops_Desc3Inputs */

const en_svc_backend_development_ops_desc3 = /** @type {(inputs: Svc_Backend_Development_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Structured logs, metrics, and tracing wired in from the first endpoint, not bolted on after an outage.`)
};

const ar_svc_backend_development_ops_desc3 = /** @type {(inputs: Svc_Backend_Development_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجلات منظمة ومقاييس وتتبع موصول من أول نقطة نهاية, لا ملحقة بعد انقطاع.`)
};

const bn_svc_backend_development_ops_desc3 = /** @type {(inputs: Svc_Backend_Development_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রথম এন্ডপয়েন্ট থেকেই স্ট্রাকচার্ড লগ, মেট্রিক ও ট্রেসিং, আউটেজের পর লাগানো নয়।`)
};

const de_svc_backend_development_ops_desc3 = /** @type {(inputs: Svc_Backend_Development_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strukturierte Protokolle, Metriken und Ablaufverfolgung, die vom ersten Endpunkt aus integriert sind und nach einem Ausfall nicht hinzugefügt werden.`)
};

const es_svc_backend_development_ops_desc3 = /** @type {(inputs: Svc_Backend_Development_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registros estructurados, métricas y seguimiento conectados desde el primer punto final, no incorporados después de una interrupción.`)
};

const fr_svc_backend_development_ops_desc3 = /** @type {(inputs: Svc_Backend_Development_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Journaux structurés, métriques et traçage connectés à partir du premier point de terminaison, non intégrés après une panne.`)
};

const pt_svc_backend_development_ops_desc3 = /** @type {(inputs: Svc_Backend_Development_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logs estruturados, métricas e rastreamento conectados a partir do primeiro endpoint, não anexados após uma interrupção.`)
};

const zh_svc_backend_development_ops_desc3 = /** @type {(inputs: Svc_Backend_Development_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结构化日志、指标和追踪从第一个接口就接好，而不是出故障后才补上。`)
};

const tr_svc_backend_development_ops_desc3 = /** @type {(inputs: Svc_Backend_Development_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yapılandırılmış loglar, metrikler ve izleme ilk uç noktadan itibaren örülür, bir kesinti sonrası eklenmez.`)
};

const ru_svc_backend_development_ops_desc3 = /** @type {(inputs: Svc_Backend_Development_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Структурные логи, метрики и трейсинг, прокинутые с самого первого эндпоинта, а не прикрученные после сбоя.`)
};

const pl_svc_backend_development_ops_desc3 = /** @type {(inputs: Svc_Backend_Development_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ustrukturyzowane dzienniki, metryki i śledzenie podłączone do pierwszego punktu końcowego, a nie przyłączone po awarii.`)
};

/**
* | output |
* | --- |
* | "Structured logs, metrics, and tracing wired in from the first endpoint, not bolted on after an outage." |
*
* @param {Svc_Backend_Development_Ops_Desc3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_backend_development_ops_desc3 = /** @type {((inputs?: Svc_Backend_Development_Ops_Desc3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Backend_Development_Ops_Desc3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_backend_development_ops_desc3(inputs)
	if (locale === "bn") return bn_svc_backend_development_ops_desc3(inputs)
	if (locale === "de") return de_svc_backend_development_ops_desc3(inputs)
	if (locale === "es") return es_svc_backend_development_ops_desc3(inputs)
	if (locale === "fr") return fr_svc_backend_development_ops_desc3(inputs)
	if (locale === "pt") return pt_svc_backend_development_ops_desc3(inputs)
	if (locale === "zh") return zh_svc_backend_development_ops_desc3(inputs)
	if (locale === "tr") return tr_svc_backend_development_ops_desc3(inputs)
	if (locale === "ru") return ru_svc_backend_development_ops_desc3(inputs)
	if (locale === "pl") return pl_svc_backend_development_ops_desc3(inputs)
	return en_svc_backend_development_ops_desc3(inputs)
});
export { svc_backend_development_ops_desc3 as "svc_backend-development_OPS_desc" }